let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("2F69B"), load("hhss7"), load("gr3fi")]).then(() => parcelRequire('h595R'));